<div
  class="p-3"
  style="height: calc(100svh - 85px); overflow: scroll;"
>
  <h1>{{this.submitService.includeSubmit ? 'Kontrollieren und abgeben' : 'Gespeicherte Antworten'}}</h1>
  @for (aufgabe of api.fallaufgabe?.aufgaben; track aufgabe; let aIndex = $index) {
  <h3 class="mt-3">Aufgabe {{aufgabe.aufgabenIndex}}: {{aufgabe.title}}</h3>
  <hr>
  @for (teilaufgabe of this.getSortedTeilaufgaben(aIndex); track teilaufgabe) {
  @let answer = this.getAnswer(teilaufgabe._id);
  <p>
    {{aufgabe.aufgabenIndex}}.{{teilaufgabe.teilaufgabenIndex}}
    <span
      [innerHTML]="teilaufgabe.aufgabenstellung"
      (copy)="this.onQuestionCopy(teilaufgabe._id, aufgabe._id)"
    ></span>
  </p>
  @if(answer=== 'Tabellenaufgabe befüllt'){
  <p-table
    [value]="this.getTableData(aIndex, teilaufgabe._id) ?? []"
    class="mt-3 mb-3"
    showGridlines
  >
    <ng-template
      #body
      let-entry
      let-ri="rowIndex"
    >
      <tr>
        @for (col of entry; track $index) {
        @if(col.isEditable){
        <td
          [ngStyle]="{'border-top-width': (ri == 0 ? '1px' : '0')}"
          class="relative"
          style="text-align: center !important;"
        >
          {{ col.solution }}
          <i
            class="pi pi-lock absolute top-1 right-1"
            style="font-size: 7pt;"
          ></i>
        </td>
        }@else{
        @if(col.isHeader){
        <td
          [ngStyle]="{'border-top-width': (ri == 0 ? '1px' : '0')}"
          class="bg-gray-100"
          style="text-align: center !important;"
        >
          <b class="whitespace-pre">{{col.value}}</b>
        </td>
        }@else{
        <td
          [ngStyle]="{'border-top-width': (ri == 0 ? '1px' : '0')}"
          style="text-align: center !important;"
        >
          {{col.value}}
        </td>
        }
        }
        }
      </tr>
    </ng-template>
  </p-table>
  }
  @else if(answer) {
  <p class="text-success">{{answer}}</p>
  }
  @else {
  <p class="text-danger">Noch keine Antwort gespeichert.</p>
  }
  }
  }



  @if(this.submitService.includeSubmit){
  @if (this.api.fallaufgabe?.type === 'exam') {
  <div class="flex items-center p-2 mb-3">
    <p-checkbox
      #eidInput
      inputId="eidId"
      value="ok"
    />
    <label
      for="eidInput"
      class="ml-2"
    > Mit Abgabe der Prüfung erkläre ich, dass ich die Fallaufgabe selbstständig und ohne Hilfe Dritter gelöst
      habe. Mir ist
      bewusst, dass vorsätzlich oder fahrlässig falsche Angaben zum Entzug des Zertifikats führen.</label>
  </div>
  <p-button
    class="me-3"
    severity="danger"
    label="Final abgeben"
    [disabled]="!eidInput.checked"
    (onClick)="this.confirmSubmit($event)"
  />
  } @else {
  <p-button
    class="me-3"
    severity="danger"
    label="Final abgeben"
    (onClick)="this.confirmSubmit($event)"
  />
  }
  }
  <p-button
    label="Schließen"
    (onClick)="this.closeSolutionView()"
  />
</div>
<p-confirmdialog />